import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';
import type { LoadableComponent } from '@townsquare/loadable/types';

export const HomeApp: ComponentType<unknown> & LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: "home-app-entry" */ '../App'),
	loading: () => null,
});
